import React from 'react';
import styled from 'styled-components';
import { colors, fontWeight } from '@grnhse/seedling/lib/azalea/constants';

type Props = {
  errors: Array<string>;
};

const Item = styled.li`
  color: ${colors.darkRed};
  font-size: 12px;
  font-weight: ${fontWeight.heavy};
`;

export default function Errors({ errors = [] }: Props) {
  if (!errors || !errors.length) {
    return null;
  }

  return (
    <ul>
      {errors.map((error) => (
        <Item key={error} data-provides="form_error_item">
          {error}
        </Item>
      ))}
    </ul>
  );
}
